/*
 * File: /src/router/routes/referral.js
 * Created Date: Sunday June 6th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 6th June 2021 8:29:30 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */
const ReferralList = () =>
  import(
    /* webpackChunkName: "Referral" */ 'src/components/Dashboard/Views/Referral/ReferralList.vue'
  );

const ReferralProductList = () =>
  import(
    /* webpackChunkName: "Referral" */ 'src/components/Dashboard/Views/Referral/ReferralProductList.vue'
  );

export const referralsRoutes = [
  {
    path: 'contacts/referral',
    name: 'Loyalty Programs',
    component: ReferralList,
  },
  {
    path: 'contacts/referral/:referralId',
    name: 'Loyalty Program Products',
    component: ReferralProductList,
  },
];
